import { ChangePaymentMethod } from '../../components/changePaymentMethodPopup'
import { Colors, marigold } from '../../style/colors'
import { Icon, Spacer } from '../../components'
import { ItemLayout } from '../item'
import { Layout, Spacing } from '../../style/spacing'
import { SectionHeader, SectionHeaderProps } from '../../components/sectionHeader'
import { Sizes } from '../../style/sizes'
import { ToolBox } from '../../components/toolBox'
import { Typography } from '../../style/typography'
import { css } from '@emotion/react'
import { isBusinessUsageTarget } from '../../configuration/env'
import { translate } from '../../lib/localization'
import { useAppState } from '../../store'
import React from 'react'
import warningIcon from '../../images/icons/warning.svg'

export enum GapSizes {
  sm = '8px',
  md = '16px',
  lg = '24px'
}

export enum ActionsTypes {
  contract = 'contract',
  invoice = 'invoice'
}

interface MainScreenLayoutProps {
  sectionHeaderProps: SectionHeaderProps
  gapSize?: GapSizes
  className?: string
  showToolbox?: boolean
  toolBoxConfiguration?: {
    tagPicker?: boolean
    calendar?: boolean
    isDoubleDatePicker?: boolean
    contractTagManager?: boolean
    onMutation?: Function
    actions?: boolean
    actionsTypes: ActionsTypes
  }
}

export const MainScreenLayout: React.FC<MainScreenLayoutProps> =
  ({
    sectionHeaderProps,
    children,
    className = '',
    gapSize = GapSizes.md,
    showToolbox = isBusinessUsageTarget,
    toolBoxConfiguration = {
      actions: false,
      calendar: true,
      contractTagManager: false,
      isDoubleDatePicker: true,
      tagPicker: true
    }
  }) => {
    const { action } = useAppState()
    return (
      <>
        <div>
          <Spacer height={48}/>
          <div css={[Colors.BackgroundColor.marigold50, Layout.border, Colors.BorderColor.marigold500, Layout.rounded_10, Spacing.Padding.all_12]}>
            <ItemLayout
              leftElement={<Icon src={warningIcon} color={marigold['500']} size={Sizes.small} css={Spacing.Margin.right_8}/>}
              verticalAlign={false}
              firstTextRow={<div css={Typography.label.label2_700}>{translate('notification__dismission__title')}</div>}
              secondTextRow={<div css={[Colors.Color.eerieBlack800, Typography.Callout.medium, Spacing.Margin.top_4]}>
                {translate('notification__dismission__subtitle')}
              </div>}
            />
            <Spacer height={8}/>
          </div>
          <Spacer height={22}/>
          {/* TODO: NAVIGATION + ADDRESS OF THE CONTRACT */}
          <div css={[Layout.flex_justify_spaceBetween, Layout.display_flex]}>
            <SectionHeader {...sectionHeaderProps}/>
            {showToolbox && <ToolBox {...toolBoxConfiguration}/>}
          </div>
          <Spacer height={22}/>
          <div
            className={className}
            css={[
              Layout.display_flex,
              Layout.flex_column,
              Layout.hide_scrollbar,
              Spacing.Padding.all_6,
              Layout.scrollYEnabled,
              Spacing.Padding.bottom_24,
              css`border-radius: 10px;
                row-gap: ${gapSize};`]}>
            {children}
            {
              action === 'changePaymentMethod' && <ChangePaymentMethod/>
            }
          </div>
        </div>
      </>
    )
  }
